/**
 * @generated SignedSource<<af601d1c4ff54d1ee14ab40f03d6343d>>
 * @relayHash 9fe996eb874f5dede5dfc631ede9be23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006

import type { ConcreteRequest } from 'relay-runtime';
export type CommentDeletionLocation = "EDITOR" | "LIVE" | "%future added value";
export type ObjectCommentDeleteGeneralCommentMutation$variables = {
  commentIdToDelete: string;
  deleteFrom?: CommentDeletionLocation | null;
};
export type ObjectCommentDeleteGeneralCommentMutation$data = {
  readonly deleteComment: boolean | null;
};
export type ObjectCommentDeleteGeneralCommentMutation = {
  response: ObjectCommentDeleteGeneralCommentMutation$data;
  variables: ObjectCommentDeleteGeneralCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentIdToDelete"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deleteFrom"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentIdToDelete",
        "variableName": "commentIdToDelete"
      },
      {
        "kind": "Variable",
        "name": "deleteFrom",
        "variableName": "deleteFrom"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteComment"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ObjectCommentDeleteGeneralCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectCommentDeleteGeneralCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9fe996eb874f5dede5dfc631ede9be23",
    "id": "2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006",
    "metadata": {},
    "name": "ObjectCommentDeleteGeneralCommentMutation",
    "operationKind": "mutation",
    "text": "mutation ObjectCommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
  }
};
})();

(node as any).hash = "70583226681dc587971b709a0fb5f1db";

export default node;
